module.exports = __webpack_public_path__ + "static/media/innoedu1.f3448f3b.png";